import React from "react";
// import TableComandas from "../components/TableComandas";
import AppOrdenPagoReactTable from "../table/AppOrdenPagoReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const OrdenCobro = () => {
  return (
    <>
      <AppOrdenPagoReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default OrdenCobro;
